import React from "react";
import type { AnchorHTMLAttributes, ButtonHTMLAttributes } from "react";
import cn from "classnames";
import styles from "./FunctionalButton.module.scss";
import type { IFunctionalButtonProps } from "./Interfaces";
import FunctionalButtonContent from "./FunctionalButtonContent";
import { Link } from "../../link";

const FunctionalButton: React.FC<IFunctionalButtonProps> = props => {
  const {
    mode = "default",
    size = "large",
    analyticsId,
    e2eId,
    href,
    children,
    className,
    contentClassName,
    onClick,
    targetBlank,
    type = "button",
    disabled,
    ...ariaProps
  } = props;

  const classes = cn(
    styles.funcButton,
    {
      [styles.funcButton_large]: size === "large",
      [styles.funcButton_medium]: size === "medium",
      [styles.funcButton_accent]: mode === "accent",
      [styles.funcButton_delete]: mode === "delete",
    },
    className
  );
  const handleClick = (e: React.MouseEvent<HTMLElement>): void => {
    if (typeof onClick === "function") onClick(e);
  };

  let ButtonComponent;

  if (href) {
    const linkProps: AnchorHTMLAttributes<HTMLAnchorElement> = {
      ...ariaProps,
      href: href,
    };
    if (targetBlank) {
      linkProps.target = "_blank";
      linkProps.rel = "noopener noreferrer";
    }

    ButtonComponent = (
      <Link
        {...linkProps}
        href={href}
        className={classes}
        onClick={handleClick}
        data-analytics-id={analyticsId}
        data-testid={e2eId}
        role="button"
      >
        <FunctionalButtonContent className={contentClassName}>
          {children}
        </FunctionalButtonContent>
      </Link>
    );
  } else {
    const buttonProps: ButtonHTMLAttributes<HTMLButtonElement> = {
      ...ariaProps,
      disabled,
      type: type,
    };

    ButtonComponent = (
      <button
        {...buttonProps}
        className={classes}
        onClick={handleClick}
        data-analytics-id={analyticsId}
        data-testid={e2eId}
      >
        <FunctionalButtonContent className={contentClassName}>
          {children}
        </FunctionalButtonContent>
      </button>
    );
  }

  return ButtonComponent;
};
export default FunctionalButton;
